let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8tkSL")).then(() => parcelRequire('6yXvq'));